import { ComponentSharedIconCardSection } from '@peerless/data-access/strapi';
import { IconCard } from './IconCard';
import { Grid, Stack } from '@mui/material';
import { withSectionLayout } from './SectionLayout';
import { SectionHeader } from './SectionHeader';
import { CallToActionSection } from './CallToActionSection';

interface IconCardSectionProps {
  data: ComponentSharedIconCardSection;
}

function _IconCardSection({ data }: IconCardSectionProps) {
  return (
    <Stack gap={4}>
      <SectionHeader {...data.sectionHeader} />
      <Grid container spacing={3} justifyContent={'center'}>
        {data.iconCards?.map(card => {
          return (
            <Grid item xs={12} md={6} lg={4} key={card.id}>
              <IconCard
                image={card.icon}
                title={card.title}
                description={card.description}
                linktext={card.linkCopy}
                url={card.link}
              />
            </Grid>
          );
        })}
      </Grid>
      <CallToActionSection callToAction={data.callToAction} />
    </Stack>
  );
}

export const IconCardSection = withSectionLayout(_IconCardSection);
